import { useNavigate, useParams } from "react-router-dom";
import CustomOrgChart from "../../common/hierarchy/CustomOrgChart";
import { useEffect, useState } from "react";
import { getSingleOnboardingRequest, onBoardingApprovalOrRejection } from "../../../api/admin/adminApi";
import { convertHierarchy } from "../../common";
import { FaUsers } from "react-icons/fa6";
import DeleteModal from "../../common/commonModal/DeleteModal";
import { Form, Spinner } from "react-bootstrap";
import ReactNotifications from "../../common/reactNotifications/ReactNotifications";
import * as utilConstants from "../../../utils/constants/utilsConstants";

const ViewRequest = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [hierarchyData, setHierarchyData] = useState({});
    const [data, setData] = useState(null);
    const [isConfirmModal, setIsConfirmModal] = useState(false);
    const [show, setShow] = useState(false);
    const [reason, setReason] = useState("");
    const [error, setError] = useState("");
    const [activeTab, setActiveTab] = useState("hierarchy");

    const handleAccept = () => {
        const payload = { status: "approved" };

        onBoardingApprovalOrRejection(id, payload, (res) => {
            if (res?.status === true || res?.status === 200) {
                ReactNotifications(
                    res?.message || res?.data?.message || "Request approved successfully!",
                    utilConstants.sucessState200
                );
                setIsConfirmModal(false);
                navigate("/admin/onboarding-requests");
            } else {
                ReactNotifications(
                    res?.message || res?.data?.message || "Something went wrong while approving!",
                    utilConstants.getErrorStatus
                );
                console.error("Approval Error:", res);
            }
        });
    };

    const handleReject = () => {
        if (!reason.trim()) {
            setError("Reason is required.");
            return;
        }
        if (reason.trim().length < 50) {
            setError("Reason must be at least 50 characters.");
            return;
        }
        setError("");

        const payload = { status: "rejected", reason: reason.trim() };

        onBoardingApprovalOrRejection(id, payload, (res) => {
            if (res?.status === true || res?.status === 200) {
                ReactNotifications(
                    res?.message || res?.data?.message || "Request rejected successfully!",
                    utilConstants.sucessState200
                );
                setShow(false);
                navigate("/admin/onboarding-requests");
            } else {
                ReactNotifications(
                    res?.message || res?.data?.message || "Something went wrong while rejecting!",
                    utilConstants.getErrorStatus
                );
                console.error("Rejection Error:", res);
            }
        });
    };



    useEffect(() => {
        getSingleOnboardingRequest(id, (res) => {
            if (res?.status === true) {
                console.log(res, 'ff')
                setData(res?.data);
                setHierarchyData(convertHierarchy(res?.data?.hierarchy_data));
            }
        });
    }, [id]);


    if (!data) {
        return (
            <div className="flex items-center justify-center h-screen">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
            </div>
        );
    }

    const hasHierarchy = data?.hierarchy_data?.teams || data?.hierarchy_data?.company_head;
    const hasMembers = data?.hierarchy_data?.members?.length > 0;

    return (
        <div className="ViewRequest pt-3 h-[calc(100vh-75px)] flex flex-col">
            <div className="bg-gray-100 px-4 py-3 rounded mx-3">
                <div className="flex flex-col md:flex-row gap-4">
                    <div className="flex-1">
                        <h5 className="font-bold text-2xl">{data?.company_name}</h5>
                        <div className="flex items-center text-gray-500 mt-1">
                            <FaUsers className="mr-2" />
                            <span className="text-sm">
                                Size <strong className="text-gray-900 ml-1">{data?.size}</strong>
                            </span>
                        </div>
                    </div>
                    <div className="flex-[2] grid grid-cols-2 lg:grid-cols-3 gap-3 text-sm">
                        <div>
                            <span className="text-gray-500">Parent Company</span>
                            <p className="font-semibold fs-16 !mb-0">{data?.parent_company || "--"}</p>
                        </div>
                        <div>
                            <span className="text-gray-500">Team Type</span>
                            <p className="font-semibold fs-16 !mb-0">{data?.team_type}</p>
                        </div>
                        <div>
                            <span className="text-gray-500">Industry Focus</span>
                            <p className="font-semibold fs-16 !mb-0">{data?.industry_focus}</p>
                        </div>
                        <div>
                            <span className="text-gray-500 ">Website</span>
                            <p className="font-semibold text-blue-600 break-words !mb-0">{data?.website}</p>
                        </div>
                        <div>
                            <span className="text-gray-500">Country</span>
                            <p className="font-semibold fs-16 !mb-0">USA</p>
                        </div>
                        <div>
                            <span className="text-gray-500">Onboarding Contact</span>
                            <p className="font-semibold fs-16 !mb-0">{data?.onboarding_contact}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex-1 overflow-hidden">
                {hasHierarchy && hasMembers ? (
                    <div className="p-4">
                        <div className="flex border-b mb-4">
                            <button
                                className={`px-4 py-2 font-medium ${activeTab === "hierarchy"
                                    ? "border-b-2 border-black text-black font-bold"
                                    : "text-gray-500"
                                    }`}
                                onClick={() => setActiveTab("hierarchy")}
                            >
                                Hierarchy
                            </button>
                            <button
                                className={`px-4 py-2 font-medium ${activeTab === "members"
                                    ? "border-b-2 border-black text-black font-bold"
                                    : "text-gray-500"
                                    }`}
                                onClick={() => setActiveTab("members")}
                            >
                                Members
                            </button>
                        </div>


                        {activeTab === "hierarchy" && (
                            <CustomOrgChart isAddEdit={false} singleCompanyHierarchy={hierarchyData} />
                        )}

                        {activeTab === "members" && (
                            <div className="p-4 bg-gray-50 rounded-lg h-full">
                                <div className="max-h-[400px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                        {data?.hierarchy_data?.members?.map((m, idx) => (
                                            <div
                                                key={idx}
                                                className="flex items-center gap-3 bg-white border rounded-lg shadow-sm p-3"
                                            >
                                                <div className="w-12 h-12 rounded-full bg-gray-200 flex-shrink-0" />
                                                <div className="flex-1">
                                                    <div className="flex items-center gap-2">
                                                        <span className="font-semibold text-gray-900">
                                                            {m.first_name} {m.last_name}
                                                        </span>
                                                        {m.role === "owner" && (
                                                            <span className="text-xs bg-gray-200 px-2 py-0.5 rounded-full">
                                                                Owner
                                                            </span>
                                                        )}
                                                    </div>
                                                    <p className="text-sm text-gray-500 break-words">{m.email}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                ) : hasHierarchy ? (
                    <CustomOrgChart isAddEdit={false} singleCompanyHierarchy={hierarchyData} />
                ) : hasMembers ? (
                    <div className="p-4 bg-gray-50 rounded-lg h-full">
                        <div className="max-h-[400px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                {data?.hierarchy_data?.members?.map((m, idx) => (
                                    <div
                                        key={idx}
                                        className="flex items-center gap-3 bg-white border rounded-lg shadow-sm p-3"
                                    >
                                        <div className="w-12 h-12 rounded-full bg-gray-200 flex-shrink-0" />
                                        <div className="flex-1">
                                            <div className="flex items-center gap-2">
                                                <span className="font-semibold text-gray-900">
                                                    {m.first_name} {m.last_name}
                                                </span>
                                                {m.role === "owner" && (
                                                    <span className="text-xs bg-gray-200 px-2 py-0.5 rounded-full">
                                                        Owner
                                                    </span>
                                                )}
                                            </div>
                                            <p className="text-sm text-gray-500 break-words">{m.email}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ) : (
                    <p className="text-center text-gray-500 mt-5">No hierarchy or members found.</p>
                )}
            </div>
            {data?.status === "pending" && (
                <div className="flex items-center justify-center">
                    <div className="flex flex-wrap items-center justify-center gap-2 w-full md:w-1/2">
                        <h2 className="font-bold text-base mt-2 pr-3">Team Structure</h2>
                        <button
                            onClick={() => setShow(true)}
                            className="bg-[#F23154] text-white px-4 py-1 rounded-md shadow-md"
                        >
                            Reject
                        </button>
                        <button
                            onClick={() => setIsConfirmModal(true)}
                            className="bg-[#AEF468] text-gray-900 px-4 py-1 rounded-md shadow-md"
                        >
                            Accept
                        </button>
                    </div>
                </div>
            )}

            <DeleteModal
                show={isConfirmModal}
                onClose={() => setIsConfirmModal(false)}
                onConfirm={handleAccept}
                isIcon={false}
                confirmText="Accept"
                cancelButtonStyle="!bg-inherit py-1 px-4 text-dark"
                confirmButtonStyle="!bg-[#AEF468] !border-none text-dark py-1 px-4"
                title="Confirm Acceptance"
                message="Are you sure you want to Accept this request?"
            />

            <DeleteModal
                show={show}
                onClose={() => setShow(false)}
                onConfirm={handleReject}
                isIcon={false}
                confirmText="Reject"
                cancelButtonStyle="!bg-inherit py-1 px-4 text-dark"
                confirmButtonStyle="!bg-[#F23154] !border-none text-white py-1 px-4"
                title="Reason for declining the request"
                message=""
                body={
                    <div className="mb-3">
                        <Form.Group>
                            <Form.Control
                                as="textarea"
                                rows={4}
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                placeholder="Enter at least 50 characters..."
                            />
                            {error && <small className="text-danger ml-1">{error}</small>}
                        </Form.Group>
                    </div>
                }
            />
        </div>
    );
};

export default ViewRequest;
